export const createUtilityActions = (set, get) => ({
  getDesignById: (designId) => {
    return get().vehicleStorage.designs[designId];
  },

  getSelectedDesign: () => {
    const { selectedDesignId, designs } = get().vehicleStorage;
    return selectedDesignId ? designs[selectedDesignId] : null;
  },

  // Flatten design data by stacks
  getStacksWithProducts: (designId) => {
    const design = get().vehicleStorage.designs[designId];
    if (!design) return [];

    return design.Stacks.map((stack) => ({
      ...stack,
    }));
  }
});
